export enum ThreadContextActionTypes {
  // initialize
  INIT_USER_ID = 'INIT_USER_ID',
  // channel
  GET_CHANNEL_START = 'GET_CHANNEL_START',
  GET_CHANNEL_SUCCESS = 'GET_CHANNEL_SUCCESS',
  GET_CHANNEL_FAILURE = 'GET_CHANNEL_FAILURE',
  // emojis
  SET_EMOJI_CONTAINER = 'SET_EMOJI_CONTAINER',
  // parent message
  GET_PARENT_MESSAGE_START = 'GET_PARENT_MESSAGE_START',
  GET_PARENT_MESSAGE_SUCCESS = 'GET_PARENT_MESSAGE_SUCCESS',
  GET_PARENT_MESSAGE_FAILURE = 'GET_PARENT_MESSAGE_FAILURE',
  // fetch threads
  INITIALIZE_THREAD_LIST_START = 'INITIALIZE_THREAD_LIST_START',
  INITIALIZE_THREAD_LIST_SUCCESS = 'INITIALIZE_THREAD_LIST_SUCCESS',
  INITIALIZE_THREAD_LIST_FAILURE = 'INITIALIZE_THREAD_LIST_FAILURE',
  GET_PREV_MESSAGES_START = 'GET_PREV_MESSAGES_START',
  GET_PREV_MESSAGES_SUCESS = 'GET_PREV_MESSAGES_SUCESS',
  GET_PREV_MESSAGES_FAILURE = 'GET_PREV_MESSAGES_FAILURE',
  GET_NEXT_MESSAGES_START = 'GET_NEXT_MESSAGES_START',
  GET_NEXT_MESSAGES_SUCESS = 'GET_NEXT_MESSAGES_SUCESS',
  GET_NEXT_MESSAGES_FAILURE = 'GET_NEXT_MESSAGES_FAILURE',
  // handle messages
  SEND_MESSAGE_START = 'SEND_MESSAGE_START',
  SEND_MESSAGE_SUCESS = 'SEND_MESSAGE_SUCESS',
  SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE',
  RESEND_MESSAGE_START = 'RESEND_MESSAGE_START',
  ON_MESSAGE_DELETED_BY_REQ_ID = 'ON_MESSAGE_DELETED_BY_REQ_ID',
  // event handlers - message status change
  ON_MESSAGE_RECEIVED = 'ON_MESSAGE_RECEIVED',
  ON_MESSAGE_UPDATED = 'ON_MESSAGE_UPDATED',
  ON_MESSAGE_DELETED = 'ON_MESSAGE_DELETED',
  ON_REACTION_UPDATED = 'ON_REACTION_UPDATED',
  // event handlers - user status change
  ON_USER_MUTED = 'ON_USER_MUTED',
  ON_USER_UNMUTED = 'ON_USER_UNMUTED',
  ON_USER_BANNED = 'ON_USER_BANNED',
  ON_USER_UNBANNED = 'ON_USER_UNBANNED',
  ON_USER_LEFT = 'ON_USER_LEFT',
  // event handler - channel status change
  ON_CHANNEL_FROZEN = 'ON_CHANNEL_FROZEN',
  ON_CHANNEL_UNFROZEN = 'ON_CHANNEL_UNFROZEN',
  ON_OPERATOR_UPDATED = 'ON_OPERATOR_UPDATED',
}
